import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    fill: theme.palette.blue2,
    height: '24px',
    marginTop: '-2px',
    pointerEvents: 'none',
    position: 'absolute',
    left: '0',
    width: '24px',
  },
}));

const Adult = () => {
  const classes = useStyles();
  return (
    <svg
      height="24px"
      version="1.0"
      viewBox="0 0 36 80"
      xmlns="http://www.w3.org/2000/svg"
      className={`${classes.root} adult-icon`}>
      <g
        transform="translate(0.000000,85.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none">
        <path
          d="M213 731 c-13 -11 -27 -31 -33 -47 -12 -29 -4 -84 11 -84 18 0 9 -21
-13 -29 -41 -16 -57 -45 -73 -135 -19 -110 -19 -136 -1 -136 14 0 18 14 32
125 8 65 31 113 57 121 32 10 118 11 149 1 32 -10 53 -52 62 -122 14 -111 18
-125 32 -125 18 0 18 26 -1 136 -16 90 -32 119 -72 135 -23 8 -32 29 -14 29
15 0 23 55 11 84 -15 40 -50 65 -90 65 -20 0 -45 -8 -57 -18z m95 -27 c16 -11
22 -25 22 -54 0 -34 -4 -42 -30 -55 -27 -14 -33 -14 -60 0 -26 13 -30 21 -30
55 0 40 25 70 60 70 9 0 26 -7 38 -16z"
        />
        <path
          d="M178 273 c5 -207 7 -213 92 -213 85 0 87 6 92 213 4 156 3 167 -14
167 -17 0 -18 -12 -18 -159 0 -88 -3 -166 -6 -175 -9 -23 -99 -23 -108 0 -3 9
-6 87 -6 175 0 147 -1 159 -18 159 -17 0 -18 -11 -14 -167z"
        />
      </g>
    </svg>
  );
};

export default Adult;
